import { useParams, useSearchParams } from 'react-router-dom';
import { MonthParams } from '../../types';
import { toNumber } from '@/utils/toNumber/toNumber';
import dayjs from 'dayjs';

export function useRouteParams() {
  const { year, month } = useParams<MonthParams>();
  const jahr = toNumber(year) ?? dayjs().get('year');
  const monat = toNumber(month) ?? dayjs().get('month') + 1;

  const [searchParams] = useSearchParams();
  const datum = searchParams.get('datum') || '';

  return {
    routeParams: {
      jahr,
      monat,
    },
    searchParams: { datum },
  };
}
